import type {FunctionType} from "shared/types";

export const isFunction = (value: unknown): value is FunctionType => {
  return typeof value === "function";
};